import React from "react";
import Jumbotron from "../components/Jumbotron";
// import FeaturedQuarters from "../components/FeaturedQuarters";
import Link from "gatsby-link";
import CallToAction from "../components/CallToAction";
import styles from "../styles/single-job.module.scss";
import PageWrapper from "../components/PageWrapper";
import Helmet from "react-helmet";
import SocialMedia from "../components/SocialMedia";

const job = {
	category: "Students",
	category_url: "/students",
	title: "PhD fellowships ",
	location:
		"Faculty of Tropical Medicine, Mahidol University, Bangkok Thailand",
	published_date: "21 June 2017",
	author: "Dr. Jetsumon Sattabongkot Prachumsri",
	description:
		"<p>The joint Mahidol University (MU)-Penn State University (PSU) training program on malaria research is soliciting applications of motivated students, PhD scholars and junior faculty members who aim to develop a successful career in tropical diseases. This research and training program, funded by the Fogarty International Center at the National Institutes of Health, USA, aims to provide both long- and short-term training to scientists from malaria endemic regions of Thailand and Myanmar, to help junior researchers establish and develop careers as malaria researchers. This training program focuses on malaria, especially vivax malaria.</p><p>During the training period, trainees will also travel to the US Institution to attend short-term training courses in technologies, scientific meetings and workshops. </p>",
	training_period: "< 5 years",
	requirements: [
		"Bachelor’s degree or Master’s degree in biological and medical sciences."
	],
	why_mvru:
		"<p>MVRU offers opportunities to study various aspects of malaria research, including epidemiology and ecology, spatial and temporal dynamics, molecular methods of disease diagnostics, drug resistance surveillance and mechanisms, transmission blocking vaccines (TMB vaccines). Students will receive advanced training in spatial genetics, modeling and omics technologies such as genomics, proteomics, and metabolomics. With our strong network of collaborators, MVRU’s students are guided by experts internationally as well as in Thailand. Students will also have access to various training workshops in the following themes: statistics, modeling and spatial genetics, disease diagnostics, molecular and sero-epidemiology.</p>"
};

function createMarkup(markup) {
	return { __html: markup };
}

const requirements = list => {
 if (!list) {
    return null;
  } 
  
	return list.map((item, i) => {
		return <li key={"requirement-" + (i + 1)}>{item}</li>;
	});
	
};

const SingleOpportunity = ({ data, location }) => {
	const { job, faqList, cta } = data;

	return (
		<PageWrapper
			locale={job.node_locale}
			location={location}
			data={data.layout.edges[0].node}
		>
			<main role="main">
			<Helmet
					title={job.title +  " | " + (job.node_locale === "th" ? "เรียนรู้ที่ MVRU" : "Study at MVRU") + " | Mahidol Vivax Research Unit"}
					meta={[
						{ name: "description", content: job.description.content.excerpt },
						{ name: "keywords", content: "study, malaria, vivax, mahidol, tropical medicine, lab, laboratory" },
						{
							name: "og:title",
							content:
								job.title + " | " + job.node_locale === "th" ? "เรียนรู้ที่ MVRU" : "Study at MVRU" + " | Mahidol Vivax Research Unit"
						},
						{
							name: "og:description",
							content: job.description.content.excerpt
						},
						{
							name: "og:image",
							content: ""
						}
					]}
				/>
				<Jumbotron
					type="jumbotron_b"
					bottomLine={false}
					className="mb-0"
					textAlign="text-left"
					contentAlign="justify-content-start"
				>
					<ul className={styles.breadcrumbs}>
						<li>
							<Link
								to={`/${job.node_locale}/careers/study-at-mvru`}
							>
								{job.node_locale === "th" ? "เรียนรู้ที่ MVRU" : "Study at MVRU"}
							</Link>
						</li>
						<li>{job.title}</li>
					</ul>

					<h1 className={styles.single_story_title}>{job.title}</h1>
					<ul className={styles.jumbotron_meta}>
						{/* <li className="d-inline-block">
							<time>{job.published_date}</time>
						</li> */}
						<li className="d-inline-block">{job.jobLocation}</li>
					</ul>
				</Jumbotron>

				<div className={"container " + styles.article_container}>
					<div className={"row " + styles.article_content}>
						<div className={"col-12 col-md-6 col-lg-7 " + styles.article_main}>
							<h2>{job.node_locale === "th"
								? "รายละเอียด"
								: "Description"}</h2>
							<div
								className={"images-inside " + styles.content_section}
								dangerouslySetInnerHTML={createMarkup(
									job.description.content.html
								)}
							/>

							<h2>{job.node_locale === "th"
								? "ระยะเวลาการฝึกอบรม"
								: "Training Period"}</h2>
							<p>{job.trainingPeriod}</p>
							<br />
							<h2>{job.node_locale === "th"
								? "คุณสมบัติผู้สมัครงาน"
								: "Requirements"}</h2>
							<ul className={"images-inside " + styles.content_section}>
								{requirements(job.requirements)}
							</ul>
							<h2>Why study at MVRU?</h2>
							<div
								className={"images-inside " + styles.content_section}
								dangerouslySetInnerHTML={createMarkup(
									job.whyMvru.content.html
								)}
							/>
							<SocialMedia
								site={data.site.siteMetadata}
								pageTitle={job.title}
								location={location}
							/>
						</div>

						<div className={"col-12 col-md-6 col-lg-4 " + styles.article_sidebar}>
							<div className={styles.questions}>
								<h3>FAQ</h3>
								<ul className="list-unstyled">
									{faqList.edges &&
										faqList.edges.length > 0 &&
										faqList.edges.map(({ node }, i) => {
											return (
												<li
													key={"question-" + i}
													className={
														styles.question_link
													}
												>
													<Link
														to={
															"/" +
															job.node_locale +
															"/faq#" +
															node.slug
														}
													>
														<span>
															{node.question}
														</span>
														<i />
													</Link>
												</li>
											);
										})}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="grey_bg py-4">
					<CallToAction
						className="my-5"
						text={
							cta.edges[0].node.content.childMarkdownRemark.html
						}
						buttonLabel={cta.edges[0].node.buttonLabel}
						destination={`/${job.node_locale}${
							cta.edges[0].node.linkTo
						}`}
						arrow={true}
					/>
				</div>
			</main>
		</PageWrapper>
	);
};

SingleOpportunity.defaultProps = {
	job: job
};

export default SingleOpportunity;
export const pageQuery = graphql`
	query StudyOpportunityQuery($id: String!, $locale: String!) {
		site {
			siteMetadata {
				title
				siteUrl
			}
		}

		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		job: contentfulStudyOpportunity(id: { eq: $id }) {
			title
			jobLocation
			requirements
			description {
				content: childMarkdownRemark {
					html
					excerpt
				}
			}
			trainingPeriod
			whyMvru {
				content: childMarkdownRemark {
					html
				}
			}
			node_locale
			slug
			node_locale
		}

		faqList: allContentfulFaq(filter: { node_locale: { eq: $locale } }) {
			edges {
				node {
					id
					slug
					question
					node_locale
				}
			}
		}

		cta: allContentfulCallToAction(
			filter: {
				pageLocation: { eq: "singleStudy" }
				node_locale: { eq: $locale }
			}
		) {
			edges {
				node {
					id
					pageLocation
					leadingText
					content {
						childMarkdownRemark {
							html
						}
					}
					linkTo
					buttonLabel
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/single-study-template.js